import { RECIPE_IMAGEFLUX_BASE_URL_MAP } from '@shared/app/constants/imagefluxBaseUrlMap';
import type { AppEnv } from '@shared/app/types/AppEnv';
import { createImageFluxUrl } from '@shared/app/utils/createImageFluxUrl';
import { createMenuMainImageKey } from '@shared/app/utils/createRecipeS3ImageKey';
import { useRuntimeConfig } from '#imports';

export function useMenuImageUrl() {
  const APP_ENV = useRuntimeConfig().public.APP_ENV as AppEnv;

  const imageFluxBaseUrl = (() => {
    switch (APP_ENV) {
      case 'production':
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.production;
      case 'staging':
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.staging;
      default:
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.local;
    }
  })();

  function createMenuMainImageUrl({
    w,
    h,
    filename,
    menuId,
  }: {
    w?: number;
    h?: number;
    filename: string;
    menuId: number;
  }) {
    const path = createMenuMainImageKey(menuId, filename);
    return createImageFluxUrl(imageFluxBaseUrl, { w, h, path });
  }

  return {
    createMenuMainImageUrl,
  };
}
